import React from 'react';

const CrossLine = (props) => {
  return (
    <svg
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line
        x1="0.787101"
        y1="8.54759"
        x2="17.7871"
        y2="0.547591"
        stroke="#D3D6D8"
      />
    </svg>
  );
};

export default CrossLine;
